import moment from 'moment';

export default {
	state: {
		current: moment().get('Y'),
		list: []
	},
	getters: {
		currentYear: (state) => state.current,
		years: (state) => state.list
	},
	mutations: {
		PUT_CURRENT_YEAR(state, payload) {
			state.current = payload;
		},
		PUT_YEARS_LIST(state, payload) {
			state.list = payload;
		},
		PUSH_YEAR(state, payload) {
			state.list.unshift(payload);
		}
	},
	actions: {
		putCurrentYear(context, payload) {
			context.commit('PUT_CURRENT_YEAR', payload);
		},
		putYearsList(context, payload) {
			context.commit('PUT_YEARS_LIST', payload);
		},
		pushYear(context, payload) {
			context.commit('PUSH_YEAR', payload);
		}
	}
};



// WEBPACK FOOTER //
// ./sources/components/calendar/year/store.js